/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statement_Taxonomy_Editor_Level_1Inputs */

const en_statement_taxonomy_editor_level_1 = /** @type {(inputs: Statement_Taxonomy_Editor_Level_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Level 1`)
};

const nl_statement_taxonomy_editor_level_1 = /** @type {(inputs: Statement_Taxonomy_Editor_Level_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niveau 1`)
};

/**
* | output |
* | --- |
* | "Level 1" |
*
* @param {Statement_Taxonomy_Editor_Level_1Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const statement_taxonomy_editor_level_1 = /** @type {((inputs?: Statement_Taxonomy_Editor_Level_1Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statement_Taxonomy_Editor_Level_1Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_statement_taxonomy_editor_level_1(inputs)
	return en_statement_taxonomy_editor_level_1(inputs)
});